import { unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-68924185"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
import { ref, reactive, computed, watch, onMounted } from 'vue';
import { useStore } from "vuex";
import arrowLeft from '../../assets/img/leftArrow.png';
import arrowRight from '../../assets/img/rightArrow.png';
const __default__ = {
  name: 'splitPane'
};
export default /*#__PURE__*/Object.assign(__default__, {
  props: {
    value: {
      type: Number,
      default: 0.2
    },
    min: {
      type: Number,
      default: 0.15
    },
    max: {
      type: Number,
      default: 0.4
    },
    midWidth: {
      type: Number,
      default: 8
    }
  },
  emits: ['update:value'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const store = useStore();
    const isDark = ref(true);
    const state = reactive({
      isCollapse: false
    });
    let toggleCollapse = function () {
      state.isCollapse = !state.isCollapse;
    };
    let leftStyle = computed(() => {
      return {
        width: state.isCollapse ? '40px' : `${props.value * 100}%`
      };
    });
    let midStyle = computed(() => {
      return {
        left: `calc(${props.value * 100}% - ${props.midWidth / 2}px)`,
        width: `${props.midWidth}px`,
        display: state.isCollapse ? 'none' : 'block'
      };
    });
    let arrowStyle = computed(() => {
      if (state.isCollapse) {
        return {
          left: '28px'
        };
      } else {
        return {
          left: `calc(${props.value * 100}% - 13px)`
        };
      }
    });
    let rightStyle = computed(() => {
      return {
        left: state.isCollapse ? '40px' : `${props.value * 100}%`
      };
    });
    let isMouseDown = ref(false);
    let startX = ref(0);
    let outer = ref(null);
    const mousedown = e => {
      document.addEventListener('mousemove', mousemove);
      document.addEventListener('mouseup', mouseup);
      startX.value = e.pageX - e.target.offsetLeft;
      isMouseDown.value = true;
    };
    const mouseup = e => {
      isMouseDown.value = false;
    };
    let imgArrow = ref(arrowLeft);
    watch(() => state.isCollapse, (newValue, oldValue) => {
      imgArrow.value = newValue ? isDark.value ? arrowRight : arrowRight : isDark.value ? arrowLeft : arrowLeft;
    });
    const mousemove = e => {
      if (!isMouseDown.value) return;
      const outerBox = outer.value.getBoundingClientRect();
      const dis = e.pageX - outer.value.getBoundingClientRect().left;
      let result = dis / outerBox.width;
      if (result < props.min) result = props.min;
      if (result > props.max) result = props.max;
      emit('update:value', result);
    };
    onMounted(() => {
      if (state.isCollapse) {
        imgArrow.value = arrowRight;
      } else {
        imgArrow.value = arrowLeft;
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "split-pane",
        ref_key: "outer",
        ref: outer
      }, [_createElementVNode("div", {
        class: "left pane",
        style: _normalizeStyle(_unref(leftStyle))
      }, [_createElementVNode("div", {
        style: _normalizeStyle({
          display: state.isCollapse ? 'none' : 'block',
          height: '100%',
          width: '100%'
        })
      }, [_renderSlot(_ctx.$slots, "leftContent")], 4)], 4), _createElementVNode("span", {
        class: "mid pane",
        style: _normalizeStyle(_unref(midStyle)),
        onMousedown: mousedown
      }, null, 36), _createElementVNode("img", {
        src: _unref(imgArrow),
        class: "arrowBtn",
        style: _normalizeStyle(_unref(arrowStyle)),
        onClick: _cache[0] || (_cache[0] = (...args) => _unref(toggleCollapse) && _unref(toggleCollapse)(...args))
      }, null, 12, _hoisted_1), _createElementVNode("div", {
        class: "right pane",
        style: _normalizeStyle(_unref(rightStyle))
      }, [_renderSlot(_ctx.$slots, "rightContent")], 4)], 512);
    };
  }
});